<template>
    <div>
        <p>
            What are your "Get Your Life" goals? Select a category that fits your goal and then type it in to the text box provided. So for example, if your
            goal is to have surgery in the next two years, select the “health” category. You’ll be using these goals while doing activities in this app.
        </p>
        <div v-if="goal1shown">
            <div class="caption font-weight-bold mb-1">Goal #1</div>
            <v-combobox :items="myGoalsOptions" v-model="goal1category" placeholder="Select your goal category"></v-combobox>
            <v-textarea outline single-line label="What’s your goal?" :rows="1" auto-grow v-model="goal1text"></v-textarea>
        </div>
        <div v-if="goal2shown">
            <v-layout row>
                <span class="caption font-weight-bold mb-1">Goal #2</span>
                <v-spacer></v-spacer>
                <a
                    @click.prevent="
                        goal2category = '';
                        goal2text = '';
                        goal2shown = false;
                    "
                    v-if="!goal3shown"
                    >remove</a
                >
            </v-layout>
            <v-combobox :items="myGoalsOptions" v-model="goal2category" placeholder="Select your goal category"></v-combobox>
            <v-textarea outline single-line label="What’s your goal?" :rows="1" auto-grow v-model="goal2text"></v-textarea>
        </div>
        <div v-if="goal3shown">
            <v-layout row>
                <span class="caption font-weight-bold mb-1">Goal #3</span>
                <v-spacer></v-spacer>
                <a
                    @click.prevent="
                        goal3category = '';
                        goal3text = '';
                        goal3shown = false;
                    "
                    v-if="!goal4shown"
                    >remove</a
                >
            </v-layout>
            <v-combobox :items="myGoalsOptions" v-model="goal3category" placeholder="Select your goal category"></v-combobox>
            <v-textarea outline single-line label="What’s your goal?" :rows="1" auto-grow v-model="goal3text"></v-textarea>
        </div>
        <div v-if="goal4shown">
            <v-layout row>
                <span class="caption font-weight-bold mb-1">Goal #4</span>
                <v-spacer></v-spacer>
                <a
                    @click.prevent="
                        goal4category = '';
                        goal4text = '';
                        goal4shown = false;
                    "
                    >remove</a
                >
            </v-layout>
            <v-combobox :items="myGoalsOptions" v-model="goal4category" placeholder="Select your goal category"></v-combobox>
            <v-textarea outline single-line label="What’s your goal?" :rows="1" auto-grow v-model="goal4text"></v-textarea>
        </div>
        <div class="text-xs-center" v-if="!goal4shown">
            <v-btn round outline color="primary" @click="addGoal()"><v-icon>add</v-icon> Add another goal</v-btn>
        </div>
    </div>
</template>

<script>
import { get, sync } from 'vuex-pathify';

export default {
    computed: {
        goal1category: sync('section4/myGoals@1.category'),
        goal1text: sync('section4/myGoals@1.text'),
        goal1shown: sync('section4/myGoals@1.shown'),
        goal2category: sync('section4/myGoals@2.category'),
        goal2text: sync('section4/myGoals@2.text'),
        goal2shown: sync('section4/myGoals@2.shown'),
        goal3category: sync('section4/myGoals@3.category'),
        goal3text: sync('section4/myGoals@3.text'),
        goal3shown: sync('section4/myGoals@3.shown'),
        goal4category: sync('section4/myGoals@4.category'),
        goal4text: sync('section4/myGoals@4.text'),
        goal4shown: sync('section4/myGoals@4.shown'),
        myGoalsOptions: get('section4/myGoalsOptions')
    },
    methods: {
        addGoal() {
            if (!this.goal2shown) {
                this.goal2shown = true;
            } else if (!this.goal3shown) {
                this.goal3shown = true;
            } else if (!this.goal4shown) {
                this.goal4shown = true;
            }
        }
    }
};
</script>
